import { render, staticRenderFns } from "./StatsAsp.vue?vue&type=template&id=9866d2fc&"
import script from "./StatsAsp.vue?vue&type=script&lang=js&"
export * from "./StatsAsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9866d2fc')) {
      api.createRecord('9866d2fc', component.options)
    } else {
      api.reload('9866d2fc', component.options)
    }
    module.hot.accept("./StatsAsp.vue?vue&type=template&id=9866d2fc&", function () {
      api.rerender('9866d2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/purchase-activity-flash/reports/StatsAsp.vue"
export default component.exports